import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press7',
  templateUrl: './notice-press7.component.html',
  styleUrls: ['./notice-press7.component.scss']
})
export class NoticePress7Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
